import Vue from 'vue'

export const dispatchSlackMedicalRecordMessage = async (
  attendanceId,
  payload = {}
) => {
  try {
    const channel = 'bi-notifications'
    const message = `*Consulta bloqueada* ${
      import.meta.env.MODE !== 'production'
        ? `[${import.meta.env.MODE?.toUpperCase()}] `
        : ''
    }\n\nAttendance: ${attendanceId} \nPayload: ${JSON.stringify(payload)}`
    const botName = null
    const icon = null
    await Vue.prototype.api.dispatchSlackMessage(
      channel,
      message,
      botName,
      icon
    )
  } catch (error) {
    console.error('Error dispatching Slack message:', error)
  }
}
